import React from 'react';
import { useNavigate } from 'react-router-dom';

const Contact: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div style={{
        minHeight: '100vh',
        background: '#f5f5f5',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      }}>

        {/* Content */}
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '48px 24px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '48px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}>
            <h1 style={{
              fontSize: '36px',
              fontWeight: '700',
              color: '#1a3a52',
              marginBottom: '8px'
            }}>
              Contact Us
            </h1>

            <p style={{
              fontSize: '14px',
              color: '#666',
              marginBottom: '32px'
            }}>
              Get in touch with our team
            </p>

            <p style={{
              fontSize: '16px',
              lineHeight: '1.8',
              color: '#333',
              marginBottom: '32px'
            }}>
              We'd love to hear from you! Whether you have questions, feedback, or just want to say hello, feel free to reach out through any of the channels below.
            </p>

            <h2 style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#1a3a52',
              marginTop: '32px',
              marginBottom: '16px'
            }}>
              Email Support
            </h2>
            <p style={{
              fontSize: '16px',
              lineHeight: '1.8',
              color: '#333',
              marginBottom: '16px'
            }}>
              For questions, support, or feedback, please email us at:
            </p>
            <p style={{
              fontSize: '18px',
              marginBottom: '32px'
            }}>
              <a
                href="mailto:scriblishofficial@gmail.com"
                style={{
                  color: '#6C5CE7',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
              >
                scriblishofficial@gmail.com
              </a>
            </p>

            <h2 style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#1a3a52',
              marginTop: '32px',
              marginBottom: '16px'
            }}>
              Connect With Us
            </h2>
            <p style={{
              fontSize: '16px',
              lineHeight: '1.8',
              color: '#333',
              marginBottom: '24px'
            }}>
              Follow us on social media for updates, writing tips, and community highlights:
            </p>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              marginBottom: '32px'
            }}>
              <a
                href="https://www.instagram.com/scriblishofficial"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  padding: '12px 16px',
                  background: '#f8f9fa',
                  color: '#1a3a52',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '16px',
                  border: '1px solid #e0e0e0',
                  transition: 'background 0.2s'
                }}
              >
                Instagram - @scriblishofficial
              </a>
              <a
                href="https://www.threads.net/@scriblishofficial"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  padding: '12px 16px',
                  background: '#f8f9fa',
                  color: '#1a3a52',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '16px',
                  border: '1px solid #e0e0e0',
                  transition: 'background 0.2s'
                }}
              >
                Threads - @scriblishofficial
              </a>
              <a
                href="https://www.tiktok.com/@scriblish"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  padding: '12px 16px',
                  background: '#f8f9fa',
                  color: '#1a3a52',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '16px',
                  border: '1px solid #e0e0e0',
                  transition: 'background 0.2s'
                }}
              >
                TikTok - @scriblish
              </a>
              <a
                href="https://twitter.com/scriblish"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  padding: '12px 16px',
                  background: '#f8f9fa',
                  color: '#1a3a52',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '16px',
                  border: '1px solid #e0e0e0',
                  transition: 'background 0.2s'
                }}
              >
                Twitter - @scriblish
              </a>
              <a
                href="https://www.facebook.com/share/1DR1mfTTyh/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  padding: '12px 16px',
                  background: '#f8f9fa',
                  color: '#1a3a52',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '16px',
                  border: '1px solid #e0e0e0',
                  transition: 'background 0.2s'
                }}
              >
                Facebook
              </a>
            </div>

            <h2 style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#1a3a52',
              marginTop: '32px',
              marginBottom: '16px'
            }}>
              Response Time
            </h2>
            <p style={{
              fontSize: '16px',
              lineHeight: '1.8',
              color: '#333',
              marginBottom: '24px'
            }}>
              We typically respond to all inquiries within 24-48 hours during business days. For urgent safety concerns, please include "URGENT" in your subject line.
            </p>

            {/* Related Pages */}
            <div style={{
              marginTop: '48px',
              paddingTop: '32px',
              borderTop: '1px solid #e5e5e5',
              textAlign: 'center'
            }}>
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
                More Information
              </p>
              <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a href="/about" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>About</a>
                <a href="/privacy-policy" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</a>
                <a href="/community-guidelines" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Community Guidelines</a>
                <a href="/terms-of-service" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;